// src/components/MyTrippinGrid.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import { isVideoFile } from "../utils/mediaUtils";
import { CircularProgress } from '@mui/material';

function MyTrippinGrid({ fetchUrl = '/mytrippins', isOwnerTab = false }) {
  const navigate = useNavigate();
  const [trippins, setTrippins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTrippins();
  }, [fetchUrl]);

  const loadTrippins = async () => {
    try {
      setLoading(true);
      // Use whichever endpoint was passed
      const res = await axiosInstance.get(fetchUrl);
      setTrippins(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading-container">
              <CircularProgress size={40} sx={{ color: 'black' }} />
            </div>;
  }

  if (!trippins.length) {
    return (
      <div className="loading-container" style={{ height: "unset" }}>
        <p style={{ fontSize: "18px", color: "#555", textAlign: "center", marginTop: "50px" }}>
          You have no trippins here yet
        </p>
      </div>
    );
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '3px', marginTop: '20px' }}>
      {trippins.map(tr => {
        const isVideo = isVideoFile(tr.firstImageUrl);

        return (
          <div
            key={tr.trippin_id}
            onClick={() => {
              const detailPath = isOwnerTab
                ? `/mytrippins/${tr.trippin_id}`
                : `/mytrippins/tagged/${tr.trippin_id}`;

              navigate(detailPath, {
                state: {
                  trippinIds: trippins.map((t) => t.trippin_id),
                  selectedTrippinId: tr.trippin_id,
                  isMyTrippin: isOwnerTab,
                  isMyTrippinView: isOwnerTab,
                  allowTagging: isOwnerTab,
                },
              });
            }}
            style={{
              position: 'relative',
              width: '100%',
              paddingBottom: 'calc(100% * 4 / 3)',
              overflow: 'hidden',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {isVideo ? (
              <video
                src={tr.firstImageUrl}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                }}
                autoPlay
                loop
                muted
                playsInline
              />
            ) : (
              <img
                src={tr.firstImageUrl || "/defaultPlaceholder.jpg"}
                style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  top: 0,
                  left: 0,
                }}
                alt="Trippin Thumbnail"
              />
            )}

            <div
              style={{
                position: 'absolute',
                bottom: '8px',
                width: '100%',
                textAlign: 'center',
                color: 'white',
                fontWeight: 'bold'
              }}
            >
              {new Intl.DateTimeFormat('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
              }).format(new Date(tr.start_time))}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default MyTrippinGrid;
